
class ApiError extends Error {
  code: string

  constructor (code: string, message: string) {
    super(message)
    this.code = code
    this.name = this.constructor.name
    Object.setPrototypeOf(this, new.target.prototype)
  }
}

export default ApiError
